/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const s={delta:0,timestamp:0,isProcessing:!1};export{s as frameData};
//# sourceMappingURL=data.js.map
